import Container from "./Container";
import ErrorView from "./ErrorView";
import Field from "./Field";
import FooterAction from "./FooterAction";
import SubmitButton from "./SubmitButton";

const Form = {
  Container,
  ErrorView,
  Field,
  FooterAction,
  SubmitButton,
};

export default Form;
